import { render, staticRenderFns } from "./UserSwappHistory.vue?vue&type=template&id=00ca2c96&scoped=true"
import script from "./UserSwappHistory.vue?vue&type=script&lang=js"
export * from "./UserSwappHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ca2c96",
  null
  
)

export default component.exports